import Image from '@/components/atoms/Image';
import { ButtonVariants } from '@/components/atoms/legacy/Button';
import ButtonLink from '@/components/atoms/legacy/ButtonLink/ButtonLink';
import Heading, { HeadingLevels } from '@/components/atoms/legacy/Heading';
import { useAuth } from '@/hooks/useAuth';
import { BECOME_A_DEALER_ROUTE } from '@/lib/constants';
import { ScComponent } from '@/types/interfaces';
import React from 'react';

interface PackageExplanationProps extends ScComponent {
  title: string;
  text: string;
}

const PackageExplanation: React.FC<PackageExplanationProps> = ({
  className,
  title,
  text,
}) => {
  return (
    <section className={`py-[10px] ${className}`}>
      <div className="border-l-4 border-brandElectric pl-6">
        <Heading
          className={'text-title24px text-black'}
          level={HeadingLevels.H3}
        >
          {title}
        </Heading>
      </div>

      <div className={'border-l-[1px] border-neutral-400 pl-[27px] pt-3'}>
        <p className="text-body1Light text-neutral-800">{text}</p>
      </div>
    </section>
  );
};

export const PartnerPagePackages: React.FC = () => {
  const { user } = useAuth();
  return (
    <div className="flex flex-col py-[60px] m:py-[80px]">
      <div className="mb-10 flex flex-col items-center">
        <div className="mb-10">
          <span className="text-display32px">
            A <span className="text-brandElectric">connected platform</span>
          </span>
        </div>
        <Image
          src={'/images/desktop-xl-ev-13.png'}
          width={400}
          height={300}
          alt="Car dealership"
        />
      </div>
      <section className="col-span-full mb-[40px] space-y-[30px] m:flex m:gap-[40px] m:space-y-0 l:mb-[80px] l:gap-[20px] xl:col-span-10 xl:col-start-2 xl:gap-[73px]">
        <PackageExplanation
          className="m:flex-1"
          title="Reach Serious Buyers"
          text="Showcase your inventory to a large audience of highly engaged and interested buyers"
        />
        <PackageExplanation
          className="m:flex-1"
          title={'Be ahead of the curve'}
          text="Reach early adopters and stay ahead of the competition"
        />
        <PackageExplanation
          className="m:flex-1"
          title="Increase Your Exposure"
          text="EV.com's platform is optimized for search engines, making it easier for potential buyers to find your dealership"
        />
      </section>
      <ButtonLink
        href={{
          pathname: user ? BECOME_A_DEALER_ROUTE : '/sign-up',
          query: user ? null : { partner_redirect: true },
        }}
        variant={ButtonVariants.newPrimary}
        className="hidden self-center md:block"
      >
        Contact Sales
      </ButtonLink>
    </div>
  );
};
